interface ConfirmationModalProps {
    currentMode: "auto" | "monthly" | null;
    pendingMode: "auto" | "monthly" | null;
    onClose: () => void;
    onConfirm: () => void;
    isSaving: boolean;
    error: string | null;
  }
  
  const ConfirmationModal = ({ currentMode, pendingMode, onClose, onConfirm, isSaving, error }: ConfirmationModalProps) => {
    const handleModalInteraction = (e: React.MouseEvent) => {
      e.stopPropagation();
    };
  
    return (
      <div
        id="confirm-toggle-modal"
        tabIndex={-1}
        aria-hidden="true"
        className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-screen bg-black bg-opacity-50"
        onClick={onClose}
      >
        <div className="relative p-4 w-full max-w-xl" onClick={handleModalInteraction}>
          <div className="relative bg-white rounded-lg shadow">
            <div className="flex items-center justify-between p-4 md:p-5 rounded-t">
              <h3 className="text-lg font-semibold text-grease-100">Confirm Purchase Mode Change</h3>
              <button
                type="button"
                className="text-gray-400 bg-transparent rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                onClick={onClose}
                disabled={isSaving}
              >
                <svg
                  className="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>
            <div className="p-4 border-t">
              <p className="text-sm text-grease-200">
                You are about to switch to{" "}
                <span className="font-semibold">{pendingMode === "auto" ? "Auto-Purchase" : "Monthly-Purchase"}</span> mode.
                This will disable the current{" "}
                <span className="font-semibold">{currentMode === "auto" ? "Auto-Purchase" : "Monthly-Purchase"}</span> mode.
                Do you want to proceed?
              </p>
              <div className="bg-yellow-50 rounded-lg p-5 flex gap-4 mt-5">
                <svg
                  className="w-6 h-6 text-yellow-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <div>
                  <p className="text-sm text-grease-200">
                    Changing the purchase mode will reset any saved settings for the current mode.
                  </p>
                </div>
              </div>
              {error && (
                <div className="mt-4 p-3 bg-red-50 text-red-600 rounded-lg text-sm">
                  {error}
                </div>
              )}
            </div>
            <div className="flex gap-4 items-center justify-end p-4 md:p-5 border-t border-gray-200 rounded-b">
              <button
                className="flex items-center gap-2 p-3 bg-indigo-100 rounded-lg"
                onClick={onClose}
                disabled={isSaving}
              >
                <p className="font-medium bg-skyblue-200 text-grease-50 text-sm">
                  Cancel
                </p>
              </button>
              <button
                className={`flex items-center gap-2 p-3 ${isSaving ? 'bg-gray-400' : 'bg-[#FFD700]'} rounded-lg`}
                onClick={onConfirm}
                disabled={isSaving}
              >
                <p className="font-medium text-white text-sm">
                  {isSaving ? "Processing..." : "Confirm"}
                </p>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  export default ConfirmationModal;